<template>
  <div class="vx-card">
    <div class="flex flex-wrap" style="font-size: 40px; justify-content: center;">
      <label style="margin-top: 12px !important;">ANLIK CANBUS DATA OKUMA</label>
    </div>
    <vs-button type="filled" class="mr-2" @click="StartCanbusDataRead()">Canbus Okuma Başlat</vs-button>

    <vs-button type="filled" class="mr-2" color="danger" @click="StopCanbusDataRead()">Canbus Okuma Durdur</vs-button>
    <vs-button type="filled" class="mr-2" @click="GetCarCanbusData()">Canbus Oku</vs-button>
    <div class="vx-row ml-5 mr-5" style="margin-top:30px; margin-bottom:99px">
      <div class="vx-col md:w-1/2 w-full">
        <div class="vx-row">
          <div class="vx-col md:w-1/6 w-full">
            <b> Tarih</b>
          </div>

          <div class="vx-col md:w-1/6 w-full">
            <b> VIN</b>
          </div>
          <div class="vx-col md:w-1/6 w-full">
            <b>CanId</b>
          </div>
          <div class="vx-col md:w-1/6 w-full">
            <b>Raw D Value</b>
          </div>
          <div class="vx-col md:w-1/6 w-full">
            <b> DLC Value</b>
          </div>
          <div class="vx-col md:w-1/6 w-full">
            <b> ProcessedRawValue</b>
          </div>
        </div>

        <div v-for="item in canBusData" :key="item.carCanbusDataId" class="vx-row mt-5">
          <div class="vx-col md:w-1/6 w-full">
            {{ item.date }}
          </div>

          <div class="vx-col md:w-1/6 w-full">
            {{ item.vin }}
          </div>

          <div class="vx-col md:w-1/6 w-full">
            {{ item.canId }}
          </div>
          <div class="vx-col md:w-1/6 w-full" style="overflow-wrap: anywhere;">
            {{ item.rawData }}
          </div>
          <div class="vx-col md:w-1/6 w-full">
            {{ item.dlc }}
          </div>
          <div class="vx-col md:w-1/6 w-full">
            {{ item.processedRawValue }}
          </div>
        </div>

        <div></div>
      </div>
    </div>
  </div>
</template>

<script>
import "@/assets/scss/vuesax/extraComponents/agGridStyleOverride.scss";
import { repository } from "@/_services/repository.js";

// Cell Renderer

export default {
  components: { repository },
  data() {
    return {
      canBusData: [],
    };
  },

  methods: {
    GetCarCanbusData: async function() {
      //this.$vs.loading();
      this.canBusData = await repository.postEntity("ResearchAndDevelopment/GetCarCanbusData", {}).then((r) => r.list);
      //this.$vs.loading.close();
    },

    StopCanbusDataRead: async function() {
      //this.$vs.loading();
      repository.clearTimer("CarCanbusData");
      //this.$vs.loading.close();
    },
    StartCanbusDataRead: async function() {
      const a = setInterval(this.GetCarCanbusData, 1000);
      repository.timers(a, "CarCanbusData");
    },
  },

  created() {
    //function timers(timer, name, type, clearExisting)
    // const a = setInterval(this.GetCarCanbusData, 1000);
    // repository.timers(a, "CarCanbusData");
  },

  beforeRouteLeave(to, from, next) {
    // called when the route that renders this component is about to
    // be navigated away from.
    // has access to `this` component instance.
    this.StopCanbusDataRead();
    next();
  },
};
</script>
